import { Link, NavLink } from "react-router-dom";
import { Dashboardsvg, Fishsvg } from "../../SvgFile/Index";
import { useEffect, useState } from "react";
import Logout from "../../Component/Pages/Auth/Logout";
import SideBarLink from "../SideBarLink";

export default function Sidebar() {
  const [open, setOpen] = useState(false);
  const [links, setlinks] = useState([]);


  const user = JSON.parse(localStorage.getItem("memberData"));

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    let links = [
      {
        url: "/member/catch-return",
        roleName: "Submit Catch Return",
        icon: <Fishsvg />,
      },
      {
        url: "/maps-parking-info",
        roleName: "Map & Parking Info",
        icon: <Fishsvg />,
      },
      {
        url: "/report-an-incident",
        roleName: "Report an Incident",
        icon: <Fishsvg />,
      },
      {
        url: "/rules-regulations",
        roleName: "Rules and Regulations",
        icon: <Fishsvg />,
      },
      {
        url: "/competitions-dinners",
        roleName: "Competitions & Dinners",
        icon: <Fishsvg />,
      },
      {
        url: "/river-levels-weather",
        roleName: "River Levels & Weather",
        icon: <Fishsvg />,
      },
      {
        url: "/vehicle-check",
        roleName: "Vehicle Check",
        icon: <Fishsvg />,
      },
      {
        url: "/check-member-info",
        roleName: "Check Member Info",
        icon: <Fishsvg />,
      },

    ];

    setlinks(links);

    // eslint-disable-next-line
  }, []);



  return (
    <div class="main_container">
      <div className="intersight_menu">
        <div className="top_menu">
          <div class="brand">
            <button class="border-0 w-100 d-flex align-items-center" type="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              <span class="d-flex align-items-center justify-content-center">
                <img src="/image/fish.svg" alt="" srcset="" />
              </span>
              <div class="brand_dashboard">
                <span>Glendale Grayling Club</span>
                <h6>Est. 1838</h6>
              </div>
            </button>
          </div>

          <div class="intersight_home">
            <div class="menu_div">
              <ul>
                <li>
                  <NavLink
                    to="/member/dashboard"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <span>
                      <Dashboardsvg />
                    </span>
                    Dashboard
                  </NavLink>
                </li>
                <li class="without_label">Workspace</li>


                {links?.map((item, i) => (
                  <SideBarLink
                    key={i}
                    href={item?.url}
                    name={item.roleName}
                    icon={item.icon}
                  />
                ))}
              </ul>
              <div class="bottom_menu">
                <div class="dropdown">
                  <button class="dropdown-toggle border-0 w-100 d-flex align-items-center" type="button"
                    data-bs-toggle="dropdown" aria-expanded="false">
                    <span class="d-flex align-items-center justify-content-center person_icon">
                      <img
                        src="/image/person.svg" alt="" /></span>
                    <label class="person_name">
                      {user?.firstName} {user?.surname}
                      <span className="d-block">{user?.email}</span>
                    </label>
                  </button>
                  <ul className="dropdown-menu w-100">
                 
                    <li>
                      <Link
                        className="dropdown-item"
                        to="#"
                        onClick={() => setOpen(true)}
                      >
                        Logout
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Logout open={open} handleClose={handleClose} />
    </div>
  );
}
